/** Reality Check main map sidebar */

<template>
    <div class="sidebar-content">
        <div class="sidebar-logos">
            <a href="https://mcsuk.org">
                <svg aria-hidden="true" focusable="false">
                    <use href="#mcs-logo"></use>
                </svg>
            </a>
            <a target="_blank" href="https://www.wildlifetrusts.org/">
                <img src="/static/img/TWT_LOGO_PRIMARY_COLOUR.SVG.svg" alt="The Wildlife Trusts">
            </a>
            <a target="_blank" href="https://www.bluemarinefoundation.com">
                <img src="/static/img/BMF_Logo_CMYK_Blue.svg" alt="Blue Marine Foundation">
            </a>
        </div>
        <h1>MPA Reality Check</h1>
        <p>Insights into how fully we are protecting and managing our marine environment.</p>

        <main-map-legend/>

        <p class="link-styles"><data-sources-popup/></p>

        <p class="sidebar-bottom-text">The Reality Check is iterative, and will be reviewed as management changes.</p>

        <div class="sidebar-credits">
            <p>Data version: {{ versionCode }}</p>
            <p class="link-styles">Site by <a href="https://marinemapping.com" target="_blank">MarineMapping</a></p>
        </div>
    </div>
</template>

<script>
import DataSourcesPopup from "../common-components/data-sources-popup.vue";
import MainMapLegend from "./legend/main-map-legend.vue";


export default {
    name: "sidebar",
    components: {
        DataSourcesPopup, MainMapLegend
    },
    props: {},
    data: function () {
        return {}
    },
    methods: {},
    computed: {
        versionCode: function () {
            return mparc.versionMetadata.version_code;
        }
    },
    watch: {},
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../styles/_variables.scss";

    .sidebar-content {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        z-index: 5001;
        padding: 3px 8px 20px 8px;

        h1 {
            text-align: center;
            font-size: 18px;
            margin: 2px 0 8px 0;
        }

        p {
            font-size: 16px;
            text-align: justify;
        }

        .sidebar-bottom-text {
            font-size: 80%;
        }
    }

    .sidebar-logos {
        text-align: center;

        svg {
            fill: white;
            width: 180px;
            height: 55px;
            margin-bottom: -9px;
        }

        img {
            height: 55px;
        }

        a:last-of-type {
            img {
                height: 40px;
                margin: 0 0 5px 5px;
            }
        }

    }

    .sidebar-credits {
        margin: 20px 0 10px 0;

        p {
            font-size: 70%;
            margin: 0;
        }
    }

</style>